import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get(`${API}/admin/contacts`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setContacts(response.data);
    } catch (error) {
      console.error('Error fetching contacts:', error);
      toast.error('Failed to load contacts');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (contactId) => {
    if (!window.confirm('Are you sure you want to delete this contact?')) return;

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API}/admin/contacts/${contactId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Contact deleted');
      fetchContacts();
    } catch (error) {
      console.error('Error deleting contact:', error);
      toast.error('Failed to delete contact');
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center h-64">
      <p className="font-body text-muted-foreground">Loading contacts...</p>
    </div>;
  }

  return (
    <div data-testid="admin-contacts">
      <h1 className="font-heading text-3xl text-navy mb-6">Contact Inquiries</h1>

      <div className="grid gap-6">
        {contacts.length === 0 ? (
          <div className="bg-white rounded-xl shadow-lg p-12 text-center">
            <Mail size={48} className="text-muted-foreground mx-auto mb-4" />
            <p className="font-body text-muted-foreground">No contact inquiries yet</p>
          </div>
        ) : (
          contacts.map((contact) => (
            <div key={contact.id} className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-heading text-xl text-navy">{contact.name}</h3>
                  <p className="font-body text-sm text-muted-foreground">{contact.email}</p>
                </div>
                <button 
                  onClick={() => handleDelete(contact.id)}
                  className="p-2 hover:bg-red-50 rounded-lg transition-colors"
                  title="Delete"
                >
                  <Trash2 size={18} className="text-red-500" />
                </button>
              </div>
              <div className="mb-3">
                <p className="font-body text-sm font-semibold text-navy mb-1">Subject:</p>
                <p className="font-body text-foreground">{contact.subject}</p>
              </div>
              <div>
                <p className="font-body text-sm font-semibold text-navy mb-1">Message:</p>
                <p className="font-body text-foreground">{contact.message}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminContacts;
